import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const SignupPage: React.FC = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      alert('Passwords do not match!');
      return;
    }
    
    // In a real app, you would implement actual registration here
    console.log('Signup attempt:', { name, email, password });
    alert('Signup is currently disabled, please try again later. Apologies.');
  };
  
  return (
    <>
      <Helmet>
        <title>Sign Up | Quick Flick</title>
      </Helmet>
      <main>
        <div className="container">
          <div style={{ 
            maxWidth: '450px', 
            margin: '120px auto 50px',
            padding: '30px',
            borderRadius: '8px',
            backgroundColor: 'var(--secondary-color)'
          }}>
            <h1 className="section-title" style={{ marginBottom: '25px', textAlign: 'center' }}>Create Account</h1>
            
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Name</label>
                <input 
                  type="text" 
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Enter your full name"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Email</label>
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Password</label>
                <input 
                  type="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Create a password"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                  minLength={6}
                />
                <div style={{ marginTop: '5px', fontSize: '0.9rem', color: 'var(--light-gray)' }}>
                  Password must be at least 6 characters
                </div>
              </div>
              
              <div style={{ marginBottom: '25px' }}>
                <label style={{ display: 'block', marginBottom: '8px' }}>Confirm Password</label>
                <input 
                  type="password" 
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm your password"
                  style={{ 
                    width: '100%',
                    padding: '12px 15px',
                    borderRadius: '4px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: 'none',
                    color: 'var(--text-color)'
                  }} 
                  required
                />
              </div>
              
              <button 
                type="submit"
                className="btn btn-primary"
                style={{ width: '100%', padding: '12px', marginBottom: '20px' }}
              >
                Sign Up
              </button>
              
              <div style={{ textAlign: 'center' }}>
                <p>
                  Already have an account? <Link to="/login" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>Sign in</Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
};

export default SignupPage; 